import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ldCurrentUrl:''//广告投放 数据回传 ldUrl参数
  },
  mutations: {
    updateLdUrl(state){
      state.ldCurrentUrl = window.location.href;
    }
  },
  actions: {},
  modules: {}
});
